<template>
    <div class="label_info">
        <div>
            <span  :style="{ backgroundColor: color }" class="h-[16px] label_icon  rounded-full text-white flex items-center justify-center gap-1 text-[12px] font-normal  text-white-500">
             {{ text }}
             <span class="w-[13px]">
                <fa :icon="['fas', suffixIcon]" class="text-[12px] font-normal  text-white"></fa>
             </span>
            </span>
        </div>
        <app-label classes="pink" class="mr-1 !rounded-full" text="Valuation" suffixIcon="chevron-right"/>
        <label>@ 54 Manor house SE14 </label>
    </div>
</template>
<script setup>
import AppLabel from '@/components/AppLabel.vue';

const props = defineProps({
    color:{
        type:String,
        default:''
    },
    text:{
        type:String,
        default:''
    },
    suffixIcon:{
        type:String,
        default:''
    }
})
</script>
<style scoped>
.label_icon{
    padding: 0px 2px 0px 10px !important;
}
.label_info label {
	color: var(--gray-text, #A3A3A3);
/* Paragraph */
font-family: Inter;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
.label_info
{
display: flex;
height: 24px;
padding: 0px 8px 0px 4px;
align-items: center;
gap: 6px;
border-radius: 99px;
/* background: var(--Light-bg, #F1F5F7); */
}
</style>